var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker (2) 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 13.7634,
    fill: "#212121",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.8121 21.5054H32.5433C36.0272 21.5054 38.8515 24.3297 38.8515 27.8136V32.5448C38.8515 36.0287 36.0272 38.853 32.5433 38.853H27.8121C24.3282 38.8531 21.5039 36.0288 21.5039 32.5448V27.8136C21.5039 24.3297 24.3282 21.5054 27.8121 21.5054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.3141 21.5054H53.0453C56.5292 21.5054 59.3535 24.3297 59.3535 27.8136V32.5448C59.3535 36.0287 56.5292 38.853 53.0453 38.853H48.3141C44.8302 38.853 42.0059 36.0287 42.0059 32.5448V27.8136C42.0058 24.3297 44.8301 21.5054 48.3141 21.5054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.8121 42.0071H32.5433C36.0272 42.0071 38.8515 44.8314 38.8515 48.3153V53.0465C38.8515 56.5304 36.0272 59.3547 32.5433 59.3547H27.8121C24.3282 59.3548 21.5039 56.5305 21.5039 53.0466V48.3154C21.5039 44.8314 24.3282 42.0071 27.8121 42.0071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.3141 42.0071H53.0453C56.5292 42.0071 59.3535 44.8314 59.3535 48.3153V53.0465C59.3535 56.5305 56.5292 59.3548 53.0453 59.3548H48.3141C44.8302 59.3548 42.0059 56.5305 42.0059 53.0466V48.3154C42.0058 44.8314 44.8301 42.0071 48.3141 42.0071Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.11a7901c99bdb12d2e146c50a101a532.svg";
export { ForwardRef as ReactComponent };